export default __webpack_public_path__ + "static/media/376.93b56a0d.png";